var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"message-fade"}},[(_vm.visible)?_c('div',{class:['message-box', _vm.typeClass],style:(_vm.positionStyle)},[_c('div',{staticClass:"message-content"},[_c('span',{staticClass:"message-text"},[_vm._v(_vm._s(_vm.message))])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }